import { Button, CircularProgress } from '@mui/material';
import React, { ReactElement, SyntheticEvent, useContext } from 'react';
import { UserStatus } from '../api/models/User';
import { UserContext } from '../contexts/UserContext';



export enum ButtonType {Standard, Submit}
interface SubmitButtonProps {
    type?: 'submit' | 'reset' | 'button' | undefined;
    isLoading: boolean
    onClick?: (event: SyntheticEvent) => void;
}

export function LoadingButton(props: React.PropsWithChildren<SubmitButtonProps>): ReactElement {

    const {user} = useContext(UserContext);
    
    return (
        <Button sx={{ margin: 1 }} type={props.type} variant="contained" size="large" color="secondary" disabled ={props.isLoading || (user?.status == UserStatus.Suspended)} onClick={props.onClick}>
            {props.isLoading ? <CircularProgress sx={{ color: 'primary.contrastText' }} size={20} /> : props.children}
        </Button>
    );
}
